import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import StickerCard from '../components/StickerCard';
import SearchBar from '../components/SearchBar';

function Category({ onCategorySelect }) {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [stickers, setStickers] = useState([]);
  const [filteredStickers, setFilteredStickers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    fetchCategory();
  }, [id]);
  
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredStickers(stickers);
    } else {
      const filtered = stickers.filter(sticker =>
        sticker.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredStickers(filtered);
    }
  }, [searchTerm, stickers]);
  
  const fetchCategory = async () => {
    setLoading(true);
    try {
      const response = await fetch(`http://localhost/sticker-library/api/index.php/stickers/category/${id}`);
      const data = await response.json();
      
      if (data.data) {
        setCategory(data.data.category);
        setStickers(data.data.stickers || []);
        setFilteredStickers(data.data.stickers || []);
        
        if (onCategorySelect) {
          onCategorySelect(data.data.category);
        }
      } else {
        setError('Categoria não encontrada');
      }
    } catch (err) {
      console.error('Erro ao buscar categoria:', err);
      // Dados mockados para demonstração
      const mockCategories = {
        1: { id: 1, name: 'Bom Dia', slug: 'bom-dia', emoji: '☀️', sticker_count: 8 },
        2: { id: 2, name: 'Boa Noite', slug: 'boa-noite', emoji: '🌙', sticker_count: 6 },
        3: { id: 3, name: 'Boa Tarde', slug: 'boa-tarde', emoji: '🌤️', sticker_count: 5 },
        4: { id: 4, name: 'Férias', slug: 'ferias', emoji: '🏖️', sticker_count: 4 },
        5: { id: 5, name: 'Maternidade', slug: 'maternidade', emoji: '👶', sticker_count: 5 },
        6: { id: 6, name: 'Afiliadas', slug: 'afiliadas', emoji: '💚', sticker_count: 4 },
        7: { id: 7, name: 'Dias da Semana', slug: 'dias-da-semana', emoji: '📅', sticker_count: 7 },
        8: { id: 8, name: 'Pet', slug: 'pet', emoji: '🐾', sticker_count: 4 },
        9: { id: 9, name: 'Café', slug: 'cafe', emoji: '☕', sticker_count: 3 },
        10: { id: 10, name: 'Frases', slug: 'frases', emoji: '✍️', sticker_count: 6 },
        11: { id: 11, name: 'Academia', slug: 'academia', emoji: '💪', sticker_count: 4 },
        12: { id: 12, name: 'Clima', slug: 'clima', emoji: '🌦️', sticker_count: 3 },
        13: { id: 13, name: 'Lar e Rotina', slug: 'lar-e-rotina', emoji: '🏠', sticker_count: 5 },
        14: { id: 14, name: 'Fé e Espiritualidade', slug: 'fe-e-espiritualidade', emoji: '🙏', sticker_count: 5 },
        15: { id: 15, name: 'Auto Cuidado', slug: 'auto-cuidado', emoji: '🧘', sticker_count: 4 },
        16: { id: 16, name: 'Comida', slug: 'comida', emoji: '🍔', sticker_count: 4 },
        17: { id: 17, name: 'Home Office', slug: 'home-office', emoji: '💻', sticker_count: 3 }
      };
      
      const mockStickers = [
        { id: 1, name: 'Bom Dia Tiriás', slug: 'bom-dia-tirias', image_path: '', category_id: id },
        { id: 2, name: 'Good Morning', slug: 'good-morning', image_path: '', category_id: id },
        { id: 3, name: 'Bom Dia Amor', slug: 'bom-dia-amor', image_path: '', category_id: id },
        { id: 4, name: 'Um dia por vez', slug: 'um-dia-por-vez', image_path: '', category_id: id },
        { id: 5, name: 'Bom Dia Já Agradeceu Hoje?', slug: 'bom-dia-ja-agradeceu', image_path: '', category_id: id },
        { id: 6, name: 'Morning Sunshine', slug: 'morning-sunshine', image_path: '', category_id: id },
        { id: 7, name: 'Bom dia meus amores', slug: 'bom-dia-meus-amores', image_path: '', category_id: id },
        { id: 8, name: 'Olá dia lindo', slug: 'ola-dia-lindo', image_path: '', category_id: id }
      ];
      
      setCategory(mockCategories[id] || { id: id, name: 'Categoria', emoji: '📁', sticker_count: 8 });
      setStickers(mockStickers);
      setFilteredStickers(mockStickers);
    } finally {
      setLoading(false);
    }
  };
  
  const handleFavoriteToggle = (stickerId, isFavorite) => {
    // Atualizar estado local se necessário
  };
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">❌</div>
        <h3 className="empty-state-title">{error}</h3>
        <Link to="/" className="btn btn-primary" style={{ marginTop: '16px' }}>
          Voltar à Biblioteca
        </Link>
      </div>
    );
  }
  
  return (
    <div className="category-page">
      {/* Back Button */}
      <Link to="/" className="back-button">
        <HiOutlineArrowLeft />
        Voltar à biblioteca
      </Link>
      
      {/* Category Header */}
      <div className="category-header">
        <div className="category-header-emoji">{category?.emoji}</div>
        <div className="category-header-info">
          <h1>{category?.name}</h1>
          <p>{stickers.length} stickers</p>
        </div>
      </div>
      
      {/* Search */}
      <SearchBar 
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder="Buscar sticker pelo nome..."
      />
      
      {/* Stickers Grid */}
      {filteredStickers.length > 0 ? (
        <div className="stickers-grid">
          {filteredStickers.map((sticker) => (
            <StickerCard 
              key={sticker.id}
              sticker={sticker}
              onFavoriteToggle={handleFavoriteToggle}
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">🔍</div>
          <h3 className="empty-state-title">
            {searchTerm ? 'Nenhum sticker encontrado' : 'Nenhum sticker nesta categoria'}
          </h3>
          <p className="empty-state-text">
            {searchTerm 
              ? 'Tente buscar com outros termos.'
              : 'Esta categoria ainda não possui stickers. Volte mais tarde!'}
          </p>
        </div>
      )}
    </div>
  );
}

export default Category;
